export const menu = {
    "key":null,
    "response":{
        "code":"1",
        "errorCode":"0000",
        "message":null,
        "time":"2021-06-22 15:16:46"
    },
    "data":{
        "version":{
            "version":312,
            "last_up_time":"2021-06-22T15:16:46.1698749+08:00",
            "expired":7200
        },
        "value":{
            "Datas":[
                {
                    "Code": "WSFT_Product",
                    "PCode": "WebSiteFrontTop",
                    "Label": "首頁",
                    "LabelEN": "Home",
                    "Href": "#/home",
                    "Icon": "doterraLogo.jpg",
                    "RoleCode": "",
                    "Description": null,
                    "Remark": null,
                    "IsLeaf": 1,
                    "Sort": 1,
                    "Event": "onblur",
                    "MenuFlag": 10,
                    "Channel": "WebSite",
                    "Childs": [],
                    "ValidFrom": null,
                    "ValidTo": null,
                    "VF": "1900-01-01",
                    "VT": "3000-01-01",
                    "Flag1": 0,
                    "Flag2": 0,
                    "ExtStr1": null,
                    "ExtStr2": null
                },
                {
                    "Code": "WSFT_Shopcart",
                    "PCode": "WebSiteFrontTop",
                    "Label": "購物車",
                    "LabelEN": "Cart",
                    "Href": "#/order/cart",
                    "Icon": "http://doc.doterra.cn/uploads/WebSite/Menu/shopcart.jpg",
                    "RoleCode": "",
                    "Description": null,
                    "Remark": null,
                    "IsLeaf": 1,
                    "Sort": 8,
                    "Event": "onblur",
                    "MenuFlag": 10,
                    "Channel": "WebSite",
                    "Childs": [],
                    "ValidFrom": null,
                    "ValidTo": null,
                    "VF": "1900-01-01",
                    "VT": "3000-01-01",
                    "Flag1": 0,
                    "Flag2": 0,
                    "ExtStr1": null,
                    "ExtStr2": null
                },
                {
                    "Code": "WSFT_Orders",
                    "PCode": "WebSiteFrontTop",
                    "Label": "個人中心",
                    "LabelEN": "Personal Center",
                    "Href": "",
                    "Icon": "",
                    "RoleCode": "",
                    "Description": null,
                    "Remark": null,
                    "IsLeaf": 0,
                    "Sort": 4,
                    "Event": "onblur",
                    "MenuFlag": 10,
                    "Channel": "WebSite",
                    "Childs": [
                        {
                            "Code": "Address",
                            "PCode": "WSFT_Orders",
                            "Label": "地址管理",
                            "LabelEN": "Address Management",
                            "Href": "#/order/address",
                            "Icon": "",
                            "RoleCode": "",
                            "Description": null,
                            "Remark": null,
                            "IsLeaf": 0,
                            "Sort": 0,
                            "Event": "onblur",
                            "MenuFlag": 10,
                            "Channel": "WebSite",
                            "Childs": [],
                            "ValidFrom": "2020-01-01T00:00:00",
                            "ValidTo": "3000-01-01T00:00:00",
                            "VF": "2020-01-01 00:00:00",
                            "VT": "3000-01-01 00:00:00",
                            "Flag1": 0,
                            "Flag2": 0,
                            "ExtStr1": null,
                            "ExtStr2": null
                        },
                        {
                            "Code": "Order",
                            "PCode": "WSFT_Orders",
                            "Label": "我的訂單",
                            "LabelEN": "My Order",
                            "Href": "#/order/orders",
                            "Icon": "",
                            "RoleCode": "",
                            "Description": null,
                            "Remark": null,
                            "IsLeaf": 0,
                            "Sort": 0,
                            "Event": "onblur",
                            "MenuFlag": 10,
                            "Channel": "WebSite",
                            "Childs": [],
                            "ValidFrom": "2020-01-01T00:00:00",
                            "ValidTo": "3000-01-01T00:00:00",
                            "VF": "2020-01-01 00:00:00",
                            "VT": "3000-01-01 00:00:00",
                            "Flag1": 0,
                            "Flag2": 0,
                            "ExtStr1": null,
                            "ExtStr2": null
                        },
                    ],
                    "ValidFrom": null,
                    "ValidTo": null,
                    "VF": "1900-01-01",
                    "VT": "3000-01-01",
                    "Flag1": 0,
                    "Flag2": 0,
                    "ExtStr1": null,
                    "ExtStr2": null
                },
            ],
            "ValidFrom":null,
            "ValidTo":null,
            "VF":"1900-01-01",
            "VT":"3000-01-01",
            "Flag1":0,
            "Flag2":0,
            "ExtStr1":null,
            "ExtStr2":null
        }
    },
    "request":null
}